import s from './FindPortal.module.scss';

interface Props {
  name: string;
  logoUrl?: string;
}

const initialsFor = (name: string): string =>
  name
    .split(/\s+/)
    .filter((word) => /^[\p{L}\p{N}]/u.test(word))
    .slice(0, 2)
    .map((word) => word[0])
    .join('')
    .toUpperCase();

export const LenderAvatar = ({ name, logoUrl }: Props) =>
  logoUrl ? (
    <img className={s.avatar} src={logoUrl} alt="" />
  ) : (
    <span className={s.avatar} aria-hidden="true">
      {initialsFor(name)}
    </span>
  );
